import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { GetQuoteUIError } from "./errors";

var Delivery = /*#__PURE__*/function () {
  function Delivery(config, axiosInstance) {
    _classCallCheck(this, Delivery);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axiosInstance;
    this.config = config;
  }

  _createClass(Delivery, [{
    key: "getQuote",
    value: function getQuote(pickupTime, req) {
      return this.axios.post(this.config.postfix.EXTERNAL_DELIVERY_CREATE_QUOTE, req).then(function (response) {
        return response.data;
      })["catch"](function (error) {
        throw new GetQuoteUIError(error);
      });
    }
  }, {
    key: "createExternalDelivery",
    value: function createExternalDelivery(req) {
      return this.axios.post(this.config.postfix.EXTERNAL_DELIVERY_CREATE, req).then(function (response) {
        return response.data;
      })["catch"](function (error) {
        console.error(error);
        throw error;
      });
    }
  }]);

  return Delivery;
}();

export { Delivery as default };